module.exports = __webpack_public_path__ + "static/img/sm_js_4.4d970a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sm/sm_js_4.png
// module id = 9hZY
// module chunks = 1